import ContaPagar from "../contaPagar/ContaPagar";
import ItemExtrato from "./ItemExtrato";

export default class DocumentoExtrato {
    documento: string;
    itens: ItemExtrato[];

    constructor(
        documento: string,
        itens: ItemExtrato[],
    ) {
        this.documento = documento;
        this.itens = itens;
    }
}